import { z } from 'zod'

export const DOC_CHAT_CAPABILITIES_PATH = '/api/v2/documents/chat/capabilities'

export const DocChatModelInfoSchema = z.object({
  model: z.string(),
  thinking_levels: z.array(z.string()),
  default_thinking_level: z.string(),
})

export type DocChatModelInfo = z.infer<typeof DocChatModelInfoSchema>

export const DocChatCapabilityManifestSchema = z.object({
  capabilities: z.array(z.string()),
  agents: z.array(z.string()),
  tools: z.array(z.string()),
  multi_call: z.boolean(),
  // Optional so an older backend that omits them still parses; the switcher
  // falls back to its built-in list in that case.
  models: z.array(DocChatModelInfoSchema).default([]),
  default_model: z.string().nullable().default(null),
})

export type DocChatCapabilityManifest = z.infer<
  typeof DocChatCapabilityManifestSchema
>

export function docChatCapabilitiesUrl(
  powerBackendUrl: string,
  siteId: string
): string {
  const url = new URL(DOC_CHAT_CAPABILITIES_PATH, powerBackendUrl)
  url.searchParams.set('site_id', siteId)
  return url.toString()
}

export function hasDocChatCapability(
  manifest: DocChatCapabilityManifest | undefined,
  capability: string
): boolean {
  return manifest?.capabilities.includes(capability) ?? false
}
